<template>
  <div>
    <form @submit.prevent="doSubmit">
      <validation-observer ref="observer">
        <p class="is-size-3 has-text-weight-bold">
          {{ $t("mp:activate_user.title") }}
        </p>

        <PasswordCheckerInput
          v-model="password"
          @validated="passwordValid = $event"
        />

        <b-field class="mt-5">
          <b-button
            type="is-blue"
            native-type="submit"
            :loading="submitted"
            expanded
            >{{ $t("mp:activate_user.button.submit") }}
          </b-button>
        </b-field>
      </validation-observer>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import i18n from "../plugins/i18n";

export default {
  name: "ActiveUser",
  title: "mp:page.activate_user.title",
  components: {
    PasswordCheckerInput: () =>
      import("@/components/input/PasswordCheckerInput.vue"),
  },
  data() {
    return {
      passwordValid: false,
      password: "",
      submitted: false,
      token: null,
    };
  },
  mounted() {
    this.token = this.$route.query.tk;
    if (!this.token) {
      this.$router.push("/login");
      return;
    }

    if (this.loggedIn) {
      this.$router.push("/user/profile");
    }
  },
  computed: {
    ...mapGetters({
      loggedIn: "session/isReady",
    }),
  },
  methods: {
    async doSubmit() {
      if (!this.passwordValid) return;

      this.submitted = true;

      try {
        await this.$store.dispatch("session/activate", {
          token: this.token,
          password: this.password,
        });

        await this.$router.push("/profile");
      } catch (ex) {
        console.error(ex);
        this.$buefy.toast.open({
          message: i18n.t("mp:activate_user.error.general"),
          type: "is-danger",
        });
      } finally {
        this.submitted = false;
      }
    },
  },
};
</script>
